import { useSnapshot } from 'valtio';

import Text from '@cartwhl/ui/base/TextNew';

import { userStore } from 'stores/global';

import { useAssetLibraryEmbedConfig } from '../assetLibraryEmbedContext';
import { useStore } from '../assetLibraryStore';
import { isAssetLibrarySubView } from '../assetLibraryView';
import { getAssetLibraryTitle } from '../utils';
import AssetLibrarySubViewHeader from './AssetLibrarySubViewHeader';
import AssetLibraryViewNavButtons from './AssetLibraryViewNavButtons';

export interface AssetLibraryEmbeddedHeaderProps {
  titleSuffix?: string;
}

export default function AssetLibraryEmbeddedHeader({
  titleSuffix,
}: AssetLibraryEmbeddedHeaderProps) {
  const store = useStore();
  const embedConfig = useAssetLibraryEmbedConfig();
  const { libraryView } = store.state;
  const { organizationInfo } = useSnapshot(userStore.state);
  const libraryTitle = getAssetLibraryTitle(organizationInfo?.planType);
  const heading = embedConfig?.title ?? libraryTitle;
  const isMediaPicker = Boolean(embedConfig?.mediaSelection);

  if (isAssetLibrarySubView(libraryView)) {
    return (
      <div className="flex flex-none flex-col gap-3 p-4 sm:gap-4 sm:p-6 sm:pb-4 sm:pt-6">
        <AssetLibrarySubViewHeader embedded />
      </div>
    );
  }

  return (
    <div
      className={`flex flex-none flex-col items-start justify-between ${isMediaPicker ? 'gap-4 px-4 pb-4 pt-6' : 'gap-3 p-4'} sm:flex-row sm:flex-wrap ${embedConfig?.title ? 'pt-6 sm:items-start' : 'sm:items-center'} sm:gap-4 sm:p-6 sm:pb-4 sm:pt-6`}
    >
      <Text
        as="h2"
        token="display/20/medium"
        leading="body"
        className="cw-text-box-none text-primary min-w-0 max-w-full whitespace-normal text-pretty break-words sm:flex-none"
      >
        {heading}
        {titleSuffix && !embedConfig?.title ? (
          <span className="text-tertiary">{titleSuffix}</span>
        ) : null}
      </Text>
      <AssetLibraryViewNavButtons compact />
    </div>
  );
}
